import React from 'react';
import { Card } from '../../../../../../components/Card/Card';
import { t } from '../../../../../../locales/translate';
import { useSuspenseQuery } from '@apollo/client';
import { graphql } from '../../../../../../generated';
import { Icon } from '../../../../../../components/Icon/Icon';
import { useModalPresenter } from '../../../../../../components/Modal/PresentedModal';
import { withSuspendedCard } from '../../../../../../util/suspense';
import { EditPublicTransport } from './edit_public_transport';
import { KeyValueTable } from '../../../../../../components/KeyValueTable/KeyValueTable';
import { StatusPill } from '../../../../../../components/StatusPill/StatusPill';

interface Props {
  eventId: string;
}

const PUBLIC_TRANSPORT = graphql(`
  query PublicTransport($id: ID!) {
    event(id: $id) {
      id
      publicTransportConfig {
        id
        description
        enabled
        publicTransportCompany {
          id
          name
        }
      }
    }
  }
`);

function PublicTransport$({ eventId }: Props): JSX.Element {
  const { data } = useSuspenseQuery(PUBLIC_TRANSPORT, { variables: { id: eventId } });
  const publicTransportConfig = data.event.publicTransportConfig;
  const modal = useModalPresenter();
  return (
    <Card
      title={
        <>
          <p>{t.page.event.design.publicTransport.title}</p>
          <StatusPill status={publicTransportConfig.enabled ? 'active' : 'inactive'} />
        </>
      }
      actions={<Icon name="edit" onClick={() => modal.present(EditPublicTransport, { eventId })} />}
    >
      {publicTransportConfig.enabled && (
        <KeyValueTable
          labelWidth={300}
          items={[
            {
              key: t.page.event.design.publicTransport.company,
              value: publicTransportConfig.publicTransportCompany?.name || '-',
            },
            {
              key: t.page.event.design.publicTransport.description,
              value: publicTransportConfig.description || '-',
            },
          ]}
        />
      )}
    </Card>
  );
}

export const PublicTransport = withSuspendedCard(PublicTransport$, {
  loadingTitle: t.page.event.design.publicTransport.title,
});
